
















ENV = require "config/env"
FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	props: ["post"]
	components:
		pageTemplateProjectHeader: require "components/page/about/Header"
		htmlRenderer: require "components/common/htmlRenderer"
	computed:
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		pageName: -> return this.$route.name
		projectName: -> return if this.$route.params.projectName? then this.$route.params.projectName else ""
		styledTitleJa: ->
			if this.post.acf.titleHTML? then return this.post.acf.titleHTML.replace(/&lt;/g, '<') .replace(/&gt;/g, '>') .replace(/&quot;/g, '"') .replace(/&#039;/g, '\'') .replace(/&#044;/g, ',') .replace(/&amp;/g, '&')
		styledTitleEn: ->
			if this.post.acf.EnTitleHTML? then return this.post.acf.EnTitleHTML.replace(/&lt;/g, '<') .replace(/&gt;/g, '>') .replace(/&quot;/g, '"') .replace(/&#039;/g, '\'') .replace(/&#044;/g, ',') .replace(/&amp;/g, '&')
	methods:
		date: (post) -> WP.date(post)
		renderText: (ja, en) -> return if !this.isEnglish then ja else en
		category: (post) ->
			for category, index in ENV.categories
				if index < 4 then continue
				if WP.hasCategory(this.post, category.id) then return category
			return ""
		back: -> FUNCTIONS.back()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/single/singleTemplate.vue